const defaultState = {
    sortingLogic: {}
};

const storeCustomerDataReducer = (state = defaultState, action) => {

    switch (action.type) {
        case 'SAVE_CUSTOMERDATA_FULFILLED': {
            return {
                ...state,
                customerData: action.payload
            };
        }
        default: {
            return state;
        }
    }
};

export default storeCustomerDataReducer;


// WEBPACK FOOTER //
// ./src/reducers/VXC/storeCustomerData.js